import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CourseService } from '../services/course.service';

import { MessageService } from 'primeng/api';
import { CourseConstants } from '../constants/course.constants';
import { TrainingPlanDto } from '../../shared/models/trainingPlan/trainingPlanDto';
import { CourseProficiencyQuiz } from '../models/CourseProficiencyQuiz';
import { AuthRequest, AuthResult, AuthStatusType } from '../../shared/components/authentication-maintainance/model/auth.model';
import { AuthenticationHelperService } from '../../shared/components/authentication-maintainance/services/authentication-helper.service';


@Component({
  selector: 'app-course-training',
  templateUrl: './course-training.component.html',
  styleUrls: ['./course-training.component.scss']
})

export class CourseTrainingComponent implements OnInit{
  @Input() courseDetail !: any;
  @Output() reloadTrainingData = new EventEmitter<Event>();
  confirmationMessage !: string;
  buttonLabel !: string ;
  trainingPlan!: any
  trainingPlanDetails !:TrainingPlanDto
  disabled?:boolean = false;
  ifTakeQuiz : boolean = false;
  courseQuiz !: any;
  courseProficiencyQuiz !: CourseProficiencyQuiz;
  showQuiz: boolean = false;
  quizType!: any;
  @Input() trainingItemGroups: any[] = [];


  ngOnInit(): void {
    this.courseService.getTrainingDataForCourse(this.courseDetail.courseNumber).subscribe((trainingPlan)=>{
      this.trainingPlan = trainingPlan;
      this.trainingPlanDetails = this.trainingPlan;
      this.trainingPlanDetails.trainingItemGroups = this.trainingItemGroups.map(i=> i.name);
      if (this.trainingPlanDetails.isTrainingPlanCreated == true) {
        this.calculateLabelForSelfStudy();
        this.calculateLabelForInstructorLed();
        this.setCourseProficiencyQuizDetails();
      } else {
        this.disabled = true;
        this.calculateLableForNoTrainingPlan();      
      }      
    })
  }
  constructor(public courseService : CourseService,public messageService : MessageService, private cd: ChangeDetectorRef){
  }

  calculateLableForNoTrainingPlan() {
      if(this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_None) {
        this.buttonLabel = CourseConstants.CourseTraining_ButtonLabel_WithNoQuiz;
      } else {
          this.buttonLabel = CourseConstants.CourseTraining_ButtonLabel_WithQuiz;
        }
    }

  calculateLabelForSelfStudy(){

    if(this.trainingPlanDetails.courseFormat == CourseConstants.course_Format_SelfStudy_Value){
      this.quizType = 1;
      if(this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_None){
        this.displayLabelAndConfirmationForNoQuiz();
        this.ifTakeQuiz = false;
        if(this.trainingPlanDetails.isNoQuiz){
          this.disabled=!this.trainingPlanDetails.isNoQuiz;
        }
        else{
          this.disabled=!this.trainingPlanDetails.isNoQuiz;
        }
      }

      else if(this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_eQMSAutomatedGrading
        || this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_eQMSTrainerGrading){
        this.displayLabelAndConfirmationForSelfStudyQuiz();
        this.ifTakeQuiz = true;  
        if(this.trainingPlanDetails.isCourseSelfStudyWithQuiz){
          this.disabled=!this.trainingPlanDetails.isCourseSelfStudyWithQuiz;
        }
        else{
          this.disabled=!this.trainingPlanDetails.isCourseSelfStudyWithQuiz;
        }
      }
      else{
        this.displayLabelAndConfirmationForSelfStudyQuiz();
        this.disabled = true;
      }
    }
  }
  displayLabelAndConfirmationForNoQuiz(){
    this.buttonLabel = CourseConstants.CourseTraining_ButtonLabel_WithNoQuiz;
    this.confirmationMessage = CourseConstants.CourseTraining_ConfirmationMessage_WithNoQuiz;
  }

  displayLabelAndConfirmationForSelfStudyQuiz(){
    var attempts = this.trainingPlanDetails.maximumAttempts != null? this.trainingPlanDetails.maximumAttempts :
    CourseConstants.CourseTraining_MaximumAttempts_Unlimited;
    this.buttonLabel = CourseConstants.CourseTraining_ButtonLabel_WithQuiz;
    this.confirmationMessage = CourseConstants.CourseTraining_ConfirmationMessage_WithSelfStudyQuiz.replace(
          'Attempts',
          `${attempts}`);
  }

  displayLabelAndConfirmationForInstructorLedQuiz(){
    var attempts = this.trainingPlanDetails.maximumAttempts != null? this.trainingPlanDetails.maximumAttempts :
    CourseConstants.CourseTraining_MaximumAttempts_Unlimited;
    this.buttonLabel = CourseConstants.CourseTraining_ButtonLabel_WithQuiz;
        this.confirmationMessage = CourseConstants.CourseTraining_ConfirmationMessage_WithInstructorLedQuiz.replace(
          'Attempts',
          `${attempts}`);
  }

  calculateLabelForInstructorLed(){
    if(this.trainingPlanDetails.courseFormat == CourseConstants.course_Format_InstructorLed_Value){
      this.quizType = 2;
      if(this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_None){
        this.displayLabelAndConfirmationForNoQuiz();
        this.disabled = true;
      }

      else if(this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_eQMSAutomatedGrading
        || this.trainingPlanDetails.quizType == CourseConstants.CourseTraining_CourseProficiencyQuiz_eQMSTrainerGrading){
        this.displayLabelAndConfirmationForInstructorLedQuiz();
        this.ifTakeQuiz = true;  
        if(this.trainingPlanDetails.isCourseInstructorLedWithQuiz){
          this.disabled=!this.trainingPlanDetails.isCourseInstructorLedWithQuiz;
        }
        else{
          this.disabled=!this.trainingPlanDetails.isCourseInstructorLedWithQuiz;
        }
      }
      else{
        this.displayLabelAndConfirmationForInstructorLedQuiz();
        this.disabled = true;
      }
    }
  }

  updateTrainingPlan(){
    this.courseService.updateTrainingPlanForCourseTrainingItem(this.courseDetail.courseNumber)
    .subscribe({
      next: (serviceData) => {
        this.messageService.add({
          severity: CourseConstants.Severity_Success,
          summary: CourseConstants.CourseTraining_UpdatedSuccessfully
        })
        this.trainingPlanDetails.isNoQuiz = false;
        this.calculateLabelForSelfStudy();
        this.calculateLabelForInstructorLed();
        this.cd.detectChanges();
      },
      error: (error) => {
        this.messageService.add({
          severity: CourseConstants.Severity_Error,
          summary: CourseConstants.TrainingPlan_UpdateFailed
        });
        this.cd.detectChanges(); //to remove Poped up Modal & control comes back to detail screen
      }

    })
  }

  setCourseProficiencyQuizDetails() {
    if(this.trainingPlanDetails.isCourseInstructorLedWithQuiz || this.trainingPlanDetails.isCourseSelfStudyWithQuiz){
    this.courseService.getCourseProficiencyQuizDetails(this.courseDetail.courseNumber)
    .subscribe({
      next: (response) => {
        this.courseProficiencyQuiz = response;
      }
    });
   }
  }

  openQuiz() {
  this.courseService.getCourseProficiencyQuizDetails(this.courseDetail.courseNumber)
    .subscribe({
      next: (response) => {
        this.courseQuiz = response;
        this.courseProficiencyQuiz = response;
        this.showQuiz = true;
        this.cd.detectChanges();
      },
      error: (error) => {
        this.messageService.add({
          severity: CourseConstants.Severity_Error,
          summary: CourseConstants.ProficiencyQuiz_UpdateFailed
        });
        this.cd.detectChanges();//to remove Poped up Modal & control comes back to detail screen

        // Notify parent
        this.reloadCourseTraining();
      }
    });
}


  reloadCourseTraining() {
    this.reloadTrainingData.emit();    
  }
}
